export default __webpack_public_path__ + "static/media/frg--outdoor-lagoon-pool.94b7bb56.png";